import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
	position: relative;
	width: 100%;
	min-height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
	pointer-events: auto;
	background: white;
`;

export const CenterContainerStyled = styled.div``;
